module.exports = "<div class=\"panel panel-danger\">\r\n  <div class=\"panel-heading\">{{'modules.editors.unsupported.title' | translate}}</div>\r\n  <div class=\"panel-body\">\r\n    <p>{{'modules.editors.unsupported.description' | translate}}</p>\r\n  </div>\r\n</div>\r\n<psm-json-editor (jsonChanged)=\"updateConfig($event)\" [json]=\"content\"></psm-json-editor>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/presentations/widgets/unsupported/unsupported.widget.html
// module id = ./src/app/views/presentations/widgets/unsupported/unsupported.widget.html
// module chunks = main